import React from 'react'

interface DonutChartSegment {
  value: number
  color: string
}

interface DonutChartProps {
  segments: DonutChartSegment[]
  centerLabel?: string
  centerSubLabel?: string
  size?: number
  strokeWidth?: number
  className?: string
  centerContent?: React.ReactNode
}

export const DonutChart: React.FC<DonutChartProps> = ({
  segments,
  size = 100,
  strokeWidth = 12,
  className = '',
  centerContent
}) => {
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const total = segments.reduce((acc, s) => acc + s.value, 0)
  
  let currentOffset = 0

  return (
    <div className={`relative flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="rotate-[-90deg]">
        {segments.map((segment, index) => {
          const percentage = (segment.value / total) * 100
          const strokeDasharray = `${(percentage * circumference) / 100} ${circumference}`
          const strokeDashoffset = -currentOffset
          currentOffset += (percentage * circumference) / 100

          return (
            <circle
              key={index}
              cx={size / 2}
              cy={size / 2}
              r={radius}
              fill="transparent"
              stroke={segment.color}
              strokeWidth={strokeWidth}
              strokeDasharray={strokeDasharray}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
            />
          )
        })}
      </svg>
      {centerContent && (
        <div className="absolute inset-0 flex items-center justify-center">
          {centerContent}
        </div>
      )}
    </div>
  )
}

export default DonutChart
